// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"sR-z","inlineTitle":"tR-z","sponsoredAdsWrapper":"uR-z","marketplaceRecosWrapper":"vR-z"};